import type { RefObject } from 'react'

export function isContainsElement(refs: Array<RefObject<HTMLElement | null>>, target: HTMLElement | null) {
  return refs.some(ref => {
    return ref.current instanceof HTMLElement && ref.current.contains(target)
  })
}
